module.exports = __webpack_public_path__ + "img/tankOn.7838e415.gif";